module.exports = __webpack_public_path__ + "static/media/jacket.1fa38920.png";